<script setup lang="ts">
import axios from '@/api/axios';
import { ref, watch } from 'vue';
import Participant from '@/stores/communication/Participant';

const props = defineProps<{
	selection: Participant[];
}>();
const emit = defineEmits(['update:selection']);

const selection = ref<Participant[]>(props.selection || []);
const options = ref<Participant[]>([]);
const loading = ref(false);
let timer: number | null = null;

watch(selection, (v) => emit('update:selection', v));

function onSearch(q: string) {
	if (timer) clearTimeout(timer);
	timer = window.setTimeout(async () => {
		if (!q) {
			options.value = [];
			return;
		}
		loading.value = true;
		try {
			const res = await axios.get('/chat/search-user', {
				params: { q },
			});
			options.value = res.data;
		} catch (e) {
			console.error(e);
		} finally {
			loading.value = false;
		}
	}, 300);
}
</script>

<template>
	<v-autocomplete
		v-model="selection"
		:items="options"
		item-title="display_name"
		item-value="id"
		return-object
		multiple
		chips
		closable-chips
		clear-on-select
		label="Add participants"
		:loading="loading"
		@update:search="onSearch"
	/>
</template>
